import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import { authService, reportService } from '../../../services'
import { ExportType } from '../../../constants'
import { common, exportFile, formatter, log, validator } from '../../../util'
import { Link } from 'react-router-dom'
import { apiHostname } from '../../../config'

// UI
import { Button, ControlLabel, Loading, List, Page, Pager } from '../../../components'
import notify from '../../../components/Notification'
import Col from 'antd/lib/col'
import DatePicker from 'antd/lib/date-picker'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Radio from 'antd/lib/radio'
import Row from 'antd/lib/row'
import Skeleton from 'antd/lib/skeleton'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

import './styles.css'

const { RangePicker } = DatePicker

const timezone = 'Australia/Melbourne'
moment.tz.setDefault(timezone)

const pageSize = 30
const dateFormat = 'YYYY-MM-DD'

const ActionAdd = 'add'
const ActionCancel = 'cancel'
const ActionUncancel = 'uncancel'
const ActionUpdate = 'update'
const ActionAddActionTaken = 'add action taken'
const ActionTotal = 'total'
const ActionPercentageTotal = '-per-total'
const ActionGrandTotal = '-per-grand-total'
const ActionPercentageAction = '-per-action'
const ReportTypeJob = 'job'
const ReportTypeFeedback = 'feedback'
const ReportTypeCombined = 'combined'
const CombinedActionJobAdd = 'job-add'
const CombinedActionJobUpdate = 'job-update'
const CombinedActionJobCancel = 'job-cancel'
const CombinedActionJobUncancel = 'job-uncancel'
const CombinedActionFeedbackAdd = 'feedback-add'
const CombinedActionFeedbackAddActionTaken = 'feedback-add-action-taken'

const createEmptySummary = (reportType = ReportTypeJob) => ({
  total_summary: reportType === ReportTypeCombined
    ? {
      [CombinedActionJobAdd]: 0,
      [CombinedActionJobUpdate]: 0,
      [CombinedActionJobCancel]: 0,
      [CombinedActionJobUncancel]: 0,
      [CombinedActionFeedbackAdd]: 0,
      [CombinedActionFeedbackAddActionTaken]: 0,
      [ActionTotal]: 0
    }
    : reportType === ReportTypeFeedback
    ? {
      [ActionAdd]: 0,
      [ActionAddActionTaken]: 0,
      [ActionTotal]: 0
    }
    : {
      [ActionAdd]: 0,
      [ActionUpdate]: 0,
      [ActionCancel]: 0,
      [ActionUncancel]: 0,
      [ActionTotal]: 0
    },
  actions: [],
  summary: {},
  admin: '',
  role: ''
})

class TruncatedChanges extends Component {
  state = {
    isTruncated: false
  }

  componentDidMount () {
    this.measureOverflow()
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.changes !== this.props.changes) {
      this.measureOverflow()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame)
  }

  handleResize = () => {
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame)
    this.resizeFrame = window.requestAnimationFrame(this.measureOverflow)
  }

  measureOverflow = () => {
    if (!this.textElement) return

    const isTruncated = this.textElement.scrollHeight > this.textElement.clientHeight + 1
    if (isTruncated !== this.state.isTruncated) this.setState({ isTruncated })
  }

  setTextElement = (element) => {
    this.textElement = element
  }

  render () {
    const { changes = '' } = this.props
    const { isTruncated } = this.state
    const content = <div className='feedback-changes-text' ref={this.setTextElement}>{changes}</div>

    return changes && isTruncated
      ? <Tooltip title={changes}>{content}</Tooltip>
      : content
  }
}

TruncatedChanges.propTypes = {
  changes: PropTypes.string
}

export class ReportUserJobActionList extends Component {
  constructor (props) {
    super(props)
    const { match, location } = this.props
    const { key = undefined } = location
    const { dateFrom, dateTo, reportType: queryReportType } = common.getQueryStringSearchParams(location.search)

    const df = dateFrom ? moment(dateFrom) : moment().add(-1, 'day')
    const dt = dateTo ? moment(dateTo) : moment().add(-1, 'day')
    const reportType = queryReportType === ReportTypeFeedback || queryReportType === ReportTypeCombined ? queryReportType : ReportTypeJob

    this.state = {
      currentPage: 1,
      dateFrom: df,
      dateTo: dt,
      jobs: { list: [], total: 0 },
      info: createEmptySummary(reportType),
      isLoaded: false,
      isLoadedSummary: false,
      loading: false,
      loadingExport: false,
      loadingList: false,
      loadingSummary: false,
      pageKey: key,
      reportType,
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { match, location } = nextProps
    const { params = {} } = match

    // must check whether prev state key and locaction key are both undefined, and skip if it is
    if (prevState.pageKey === undefined && location.key === undefined) {

    } else if (prevState.pageKey !== location.key) {
      // not only check the page key but also need to check current path params. if within the same url path (navigate between tabs), do not reload the page.
      if (validator.isNumberText(params.id) && params.type !== undefined) {

      } else {
        if (window) window.location.reload()
      }
    }

    return { ...prevState, pageKey: location.key }
  }

  componentDidMount () {
    this.fetchSummary()
    this.fetchList()
  }

  render () {
    const { currentPage, dateFrom, dateTo, info, jobs, isLoadedSummary, loading, loadingList, loadingExport, loadingSummary, reportType } = this.state
    const code = this.getUserCode()
    const isMe = code === 'me'

    const jobColumns = [
      {
        title: 'Date',
        width: 3.5,
        render: ({ created_at }) => formatter.toStandardLongDate(created_at)
      },
      {
        title: 'Action',
        width: 1.5,
        key: 'action',
        render: ({ action }) => <div className='user-action-type' style={action === 'add' ? { background: '#52d9a733', color: '#2ed394' } : action === 'cancel' ? { background: '#e9235a22', color: '#e9235a' } : action === 'uncancel' ? { background: '#ffa50122', color: '#ffa501' } : {}}>{action.toUpperCase()}</div>
      },
      {
        title: 'Job Type',
        width: 1.5,
        key: 'type',
        render: ({ job_type }) => <div>{formatter.capitalize(job_type)}</div>
      },
      {
        title: 'Job Date',
        width: 5,
        render: ({ job_type, job_start_date, job_end_date, first_job_date, interval }) => job_type === 'recurring'
          ? `Every ${interval === 'fortnight' ? 'Fortnight ' : ''}${formatter.toDurationText(job_start_date, job_end_date, 'hh:mm A', 'ddd')}`
          : formatter.toDurationText(job_start_date, job_end_date)
      },
      {
        title: 'Client',
        width: 3.5,
        render: ({ client_id, client_fullname }) => <div><a href={`/clients/${client_id}`} rel='noopener noreferrer' target='_blank'>{client_fullname}</a></div>
      },
      {
        title: 'Employee',
        width: 3.5,
        render: ({ employee_id, employee_fullname }) => <div><a href={`/employees/${employee_id}`} rel='noopener noreferrer' target='_blank'>{employee_fullname}</a></div>
      },
      {
        title: 'Funder',
        width: 4,
        render: ({ funder_id, funder_fullname }) => <div><a href={`/funders/${funder_id}`} rel='noopener noreferrer' target='_blank'>{funder_fullname}</a></div>
      },
      {
        title: 'Single/Recurring',
        width: 2,
        render: ({ job_type, job_id, job_base_id }) => <div className='action-buttons-s2'>
          {job_id
            ? <Tooltip mouseLeaveDelay={0} title='View Job'>
              <a href={`/jobs/single/${job_id}`} rel='noopener noreferrer' target='_blank'>
                <Icon type='eye' />
              </a>
            </Tooltip>
            : <div style={{ width: '12px' }} />}
          {job_base_id
            ? <Tooltip mouseLeaveDelay={0} title='View Base Job'>
              <a href={`/jobs/recurring/${job_base_id}`} rel='noopener noreferrer' target='_blank'>
                <Icon type='eye' />
              </a>
            </Tooltip>
            : <div style={{ width: '12px' }} />}
        </div>
      }
    ]
    const feedbackColumns = [
      {
        title: 'Action Date',
        width: 3.5,
        render: ({ created_at: createdAt }) => formatter.toStandardLongDate(createdAt)
      },
      {
        title: 'Action',
        width: 1.5,
        key: 'action',
        render: ({ action = '' }) => <div className='user-action-type' style={action === ActionAdd ? { background: '#52d9a733', color: '#2ed394', width: 'auto' } : action === ActionAddActionTaken ? { background: '#ffa50122', color: '#ffa501', width: 'auto' } : { width: 'auto' }}>{action.toUpperCase()}</div>
      },
      {
        title: 'Feedback',
        width: 1.5,
        render: ({ feedback_id: feedbackId, case_no: caseNo }) => feedbackId && caseNo
          ? <Link to={`/feedbacks/${feedbackId}`} rel='noopener noreferrer' target='_blank'>#{caseNo}</Link>
          : <div>{caseNo ? `#${caseNo}` : '-'}</div>
      },
      {
        title: 'Date',
        width: 3,
        render: ({ occurred_at: occurredAt, reported_at: reportedAt }) => <div>
          <div>Report: {reportedAt ? formatter.toShortDate(reportedAt) : '-'}</div>
          <div className='wd-list-item-subtitle'>Incident: {occurredAt ? formatter.toShortDate(occurredAt) : '-'}</div>
        </div>
      },
      {
        title: 'Category',
        width: 2.5,
        render: ({ category_name: categoryName, sub_category_name: subCategoryName }) => {
          if (!categoryName) return '-'
          return subCategoryName ? <><div>{categoryName}</div><div className='wd-list-item-subtitle'>{subCategoryName}</div></> : categoryName
        }
      },
      {
        title: 'Employee',
        width: 2.5,
        render: ({ employee_id: employeeId, employee_first_name: firstName, employee_last_name: lastName }) => employeeId
          ? <Link to={`/employees/${employeeId}`} rel='noopener noreferrer' target='_blank'>{`${firstName || ''} ${lastName || ''}`.trim() || `Employee #${employeeId}`}</Link>
          : '-'
      },
      {
        title: 'Client',
        width: 2.5,
        render: ({ client_id: clientId, client_first_name: firstName, client_last_name: lastName }) => clientId
          ? <Link to={`/clients/${clientId}`} rel='noopener noreferrer' target='_blank'>{`${firstName || ''} ${lastName || ''}`.trim() || `Client #${clientId}`}</Link>
          : '-'
      },
      {
        title: 'Job',
        width: 1.5,
        render: ({ job_id: jobId }) => jobId
          ? <Link to={`/jobs/single/${jobId}`} rel='noopener noreferrer' target='_blank'>Job #{jobId}</Link>
          : '-'
      },
      {
        title: 'Changes',
        width: 5.5,
        key: 'changes',
        render: ({ changes }) => <TruncatedChanges changes={changes || ''} />
      }
    ]
    const combinedColumns = [
      {
        title: 'Action Date',
        width: 3.5,
        render: ({ created_at: createdAt }) => formatter.toStandardLongDate(createdAt)
      },
      {
        title: 'Type',
        width: 1.2,
        render: ({ report_type: reportType }) => <div>{formatter.capitalize(reportType)}</div>
      },
      {
        title: 'Action',
        width: 1.7,
        key: 'action',
        render: ({ action = '', report_type: actionReportType }) => <div className='user-action-type' style={actionReportType === ReportTypeFeedback ? action === ActionAdd ? { background: '#52d9a733', color: '#2ed394', width: 'auto' } : { background: '#ffa50122', color: '#ffa501', width: 'auto' } : action === ActionAdd ? { background: '#52d9a733', color: '#2ed394' } : action === ActionCancel ? { background: '#e9235a22', color: '#e9235a' } : action === ActionUncancel ? { background: '#ffa50122', color: '#ffa501' } : {}}>{action.toUpperCase()}</div>
      },
      {
        title: 'Feedback',
        width: 1.5,
        render: ({ report_type: itemType, feedback_id: feedbackId, case_no: caseNo }) => itemType === ReportTypeFeedback && feedbackId && caseNo
          ? <Link to={`/feedbacks/${feedbackId}`} rel='noopener noreferrer' target='_blank'>#{caseNo}</Link>
          : '-'
      },
      {
        title: 'Job Type',
        width: 1.5,
        render: ({ report_type: itemType, job_type: jobType }) => itemType === ReportTypeJob ? formatter.capitalize(jobType) : '-'
      },
      {
        title: 'Activity Date',
        width: 4.5,
        render: ({ report_type: itemType, job_type: jobType, job_start_date: jobStartDate, job_end_date: jobEndDate, interval, occurred_at: occurredAt, reported_at: reportedAt }) => itemType === ReportTypeJob
          ? jobType === 'recurring'
            ? `Every ${interval === 'fortnight' ? 'Fortnight ' : ''}${formatter.toDurationText(jobStartDate, jobEndDate, 'hh:mm A', 'ddd')}`
            : formatter.toDurationText(jobStartDate, jobEndDate)
          : <div>
            <div>Report: {reportedAt ? formatter.toShortDate(reportedAt) : '-'}</div>
            <div className='wd-list-item-subtitle'>Incident: {occurredAt ? formatter.toShortDate(occurredAt) : '-'}</div>
          </div>
      },
      {
        title: 'Category',
        width: 2.5,
        render: ({ report_type: itemType, category_name: categoryName, sub_category_name: subCategoryName }) => {
          if (itemType !== ReportTypeFeedback || !categoryName) return '-'
          return subCategoryName ? <><div>{categoryName}</div><div className='wd-list-item-subtitle'>{subCategoryName}</div></> : categoryName
        }
      },
      {
        title: 'Client',
        width: 2.5,
        render: ({ report_type: itemType, client_id: clientId, client_fullname: fullName, client_first_name: firstName, client_last_name: lastName }) => clientId
          ? <Link to={`/clients/${clientId}`} rel='noopener noreferrer' target='_blank'>{itemType === ReportTypeJob ? fullName : `${firstName || ''} ${lastName || ''}`.trim() || `Client #${clientId}`}</Link>
          : '-'
      },
      {
        title: 'Employee',
        width: 2.5,
        render: ({ report_type: itemType, employee_id: employeeId, employee_fullname: fullName, employee_first_name: firstName, employee_last_name: lastName }) => employeeId
          ? <Link to={`/employees/${employeeId}`} rel='noopener noreferrer' target='_blank'>{itemType === ReportTypeJob ? fullName : `${firstName || ''} ${lastName || ''}`.trim() || `Employee #${employeeId}`}</Link>
          : '-'
      },
      {
        title: 'Funder',
        width: 2.5,
        render: ({ report_type: itemType, funder_id: funderId, funder_fullname: funderFullName }) => itemType === ReportTypeJob && funderId
          ? <Link to={`/funders/${funderId}`} rel='noopener noreferrer' target='_blank'>{funderFullName}</Link>
          : '-'
      },
      {
        title: 'Job',
        width: 2,
        render: ({ report_type: itemType, job_id: jobId, job_base_id: jobBaseId }) => <div className='action-buttons-s2'>
          {jobId
            ? itemType === ReportTypeFeedback
              ? <Link to={`/jobs/single/${jobId}`} rel='noopener noreferrer' target='_blank'>Job #{jobId}</Link>
              : <Tooltip mouseLeaveDelay={0} title='View Job'><a href={`/jobs/single/${jobId}`} rel='noopener noreferrer' target='_blank'><Icon type='eye' /></a></Tooltip>
            : <div style={{ width: '12px' }} />}
          {itemType === ReportTypeJob && jobBaseId
            ? <Tooltip mouseLeaveDelay={0} title='View Base Job'><a href={`/jobs/recurring/${jobBaseId}`} rel='noopener noreferrer' target='_blank'><Icon type='eye' /></a></Tooltip>
            : null}
        </div>
      },
      {
        title: 'Changes',
        width: 5.5,
        key: 'changes',
        render: ({ changes }) => <TruncatedChanges changes={changes || ''} />
      }
    ]
    const columns = reportType === ReportTypeCombined ? combinedColumns : reportType === ReportTypeFeedback ? feedbackColumns : jobColumns

    const reportTitle = reportType === ReportTypeCombined ? 'System User Combined Action' : reportType === ReportTypeFeedback ? 'System User Feedback Action' : 'System User Action'
    const title = loadingSummary && !isLoadedSummary
      ? reportTitle
      : `${reportTitle}${info.admin ? ` - ${info.admin} (${info.role})` : ''}`

    return (
      <Page.Body>
        <Page.Content nomenu>
          <Page.Header title={`${title}`}>
            {(this.hasAccess('readActionReport') || isMe) && !loading
              ? <Button key={'export'} feedback={loadingExport} onClick={() => this.handleExport()}>
                Export
              </Button>
              : null}
          </Page.Header>

          <Row gutter={8}>
            <Col lg={6}>
              <ControlLabel>Report Type</ControlLabel>
              <Radio.Group
                disabled={loading || loadingExport || loadingList || loadingSummary}
                value={reportType}
                onChange={this.onChangeReportType}
              >
                <Radio.Button value={ReportTypeJob}>Job</Radio.Button>
                <Radio.Button value={ReportTypeFeedback}>Feedback</Radio.Button>
                <Radio.Button value={ReportTypeCombined}>Combined</Radio.Button>
              </Radio.Group>
            </Col>

            <Col lg={6}>
              <ControlLabel>Date Range</ControlLabel>
              <RangePicker
                disabled={loading || loadingExport || loadingList || loadingSummary}
                format="DD/MM/YYYY"
                onChange={(d1, d2) => this.onUpdateRange(d1, d2)}
                defaultValue={[dateFrom, dateTo]}
              />
            </Col>
          </Row>

          <div className='action-job-list'>
            <Skeleton loading={loading} active>
              <Spin spinning={loadingList}>
                <div className='summary-list'>
                  <table width={reportType === ReportTypeCombined ? '100%' : '70%'} style={{ marginTop: '20px' }} cellPadding='2' cellSpacing='2'>
                    <tbody>
                      {reportType === ReportTypeCombined
                        ? <tr>
                          {[
                            [CombinedActionJobAdd, 'New Job'],
                            [CombinedActionJobUpdate, 'Amend Job'],
                            [CombinedActionJobCancel, 'Cancel Job'],
                            [CombinedActionJobUncancel, 'Uncancel Job'],
                            [CombinedActionFeedbackAdd, 'New Feedback'],
                            [CombinedActionFeedbackAddActionTaken, 'New Action Taken']
                          ].map(([action, label]) => <td key={action} width='16.66%' style={{ textAlign: 'center' }}><div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[action] || 0}</div> {label}</td>)}
                        </tr>
                        : reportType === ReportTypeFeedback
                        ? <tr>
                          <td width='50%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[ActionAdd] || 0}</div> New Feedback
                          </td>
                          <td width='50%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[ActionAddActionTaken] || 0}</div> New Action Taken
                          </td>
                        </tr>
                        : <tr>
                          <td width='25%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[`${ActionAdd}`]}</div> New Job
                          </td>
                          <td width='25%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[`${ActionUpdate}`]}</div> Amend Job
                          </td>
                          <td width='25%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[`${ActionCancel}`]}</div> Cancel Job
                          </td>
                          <td width='25%' style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '16pt', fontWeight: '800' }}>{info.total_summary[`${ActionUncancel}`]}</div> Uncancel Job
                          </td>
                        </tr>}
                    </tbody>
                  </table>
                </div>

                <div className='action-job-list'>
                  <List cols={columns} rows={jobs.list} />

                  <Pager
                    size={pageSize}
                    total={jobs.total}
                    totalText={`Total ${jobs.total} action${jobs.total === 1 ? '' : 's'}`}
                    current={currentPage}
                    onChange={(e) => this.onChangePage(e)}
                    style={{ marginTop: '15px' }}
                  />
                </div>
              </Spin>
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  fetchList = () => {
    const { currentPage, isLoaded } = this.state
    this.fetchJobs({ currentPage, isLoaded })
  }

  fetchSummary = async () => {
    const { dateFrom, dateTo, reportType } = this.state
    const code = this.getUserCode()
    this.toTop()

    if (code) {
      if (this.hasAccess('readActionReport') || code === 'me') {
        this.setState({ loadingSummary: true })

        const from = dateFrom.format(dateFormat)
        const to = dateTo.format(dateFormat)
        const report = reportType === ReportTypeCombined
          ? ExportType.REPORT.USER_COMBINED_ACTION
          : reportType === ReportTypeFeedback
          ? ExportType.REPORT.USER_FEEDBACK_ACTION
          : ExportType.REPORT.USER_ACTION

        try {
          const smr = await reportService.getListByDate(report, from, to, code)
          this.setState({ info: smr, isLoadedSummary: true })
        } catch (e) {
          this.setState({ info: createEmptySummary(reportType), isLoadedSummary: true })
          notify.error('Unable to load successfully', 'Unable to load user action summary successfully. Please try again later.')
        } finally {
          this.setState({ loadingSummary: false })
        }
      }
    }
  }

  fetchJobs = async ({ currentPage, isLoaded }) => {
    const { dateFrom, dateTo, reportType } = this.state
    const code = this.getUserCode()

    if (code) {
      if (this.hasAccess('readActionReport') || code === 'me') {
        if (isLoaded) {
          this.setState({ loadingList: true })
        } else {
          this.setState({ loading: true })
        }

        const from = dateFrom.format(dateFormat)
        const to = dateTo.format(dateFormat)
        const report = reportType === ReportTypeCombined
          ? ExportType.REPORT.USER_COMBINED_ACTION
          : reportType === ReportTypeFeedback
          ? ExportType.REPORT.USER_FEEDBACK_ACTION
          : ExportType.REPORT.USER_ACTION

        try {
          const jobs = await reportService.getListByDateViewPage(report, code, from, to, currentPage, pageSize)
          this.setState({ jobs, isLoaded: true })
        } catch (e) {
          this.setState({ jobs: { list: [], total: 0 }, isLoaded: true })
          notify.error('Unable to load successfully', 'Unable to load user action list successfully. Please try again later.')
        } finally {
          this.setState({ loading: false, loadingList: false })
        }
      }
    }

    this.toTop()
  }

  onChangePage (page) {
    this.setState({ currentPage: page }, () => {
      this.fetchList()
    })
  }

  onUpdateRange (d1, d2) {
    const { loading, loadingList, loadingExport, loadingSummary } = this.state

    if (loading || loadingList || loadingExport || loadingSummary) return

    if (validator.isNotEmptyArray(d1)) {
      this.setState({ currentPage: 1, dateFrom: d1[0], dateTo: d1[1], isLoaded: false }, () => {
        this.fetchSummary()
        this.fetchList()
      })
    }
  }

  onChangeReportType = (event) => {
    const reportType = event.target.value

    this.setState({
      currentPage: 1,
      info: createEmptySummary(reportType),
      isLoaded: false,
      isLoadedSummary: false,
      jobs: { list: [], total: 0 },
      reportType
    }, () => {
      this.fetchSummary()
      this.fetchList()
    })
  }

  handleExport = async () => {
    const { dateFrom, dateTo, loadingExport, loading, loadingList, loadingSummary, reportType } = this.state
    const code = this.getUserCode()
    const isMe = code === 'me'

    if (loadingExport || loading || loadingList || loadingSummary || !(this.hasAccess('readActionReport') || isMe)) return

    this.setState({ loadingExport: true })

    try {
      const report = reportType === ReportTypeCombined
        ? ExportType.REPORT.USER_COMBINED_ACTION
        : reportType === ReportTypeFeedback
        ? ExportType.REPORT.USER_FEEDBACK_ACTION
        : ExportType.REPORT.USER_ACTION
      await exportFile.fetchReportExport(report, { user: code, from: dateFrom, to: dateTo })
    } catch (e) {
      notify.error('Unable to Export the Report', 'Please try again later.')
    } finally {
      this.setState({ loadingExport: false })
    }
  }

  getUserCode = () => {
    const { match } = this.props
    const { params } = match
    const { usercode } = params

    return usercode
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  toTop () {
    if (window) {
      window.scrollTo(0, 0)
    }
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(ReportUserJobActionList))
